import { createContext, useContext } from 'react';

import { isEmpty } from 'lodash';

import { ISession } from 'shared/domain/entities';

export type TFeedbackState = 'NPS' | 'RECOMMENDATION';

interface ISessionFeedbackContext {
  state: TFeedbackState;
  session: ISession;
  googleEvaluationLink?: string;
  setState(state: TFeedbackState): void;
}

const SessionFeedbackContext = createContext({} as ISessionFeedbackContext);

export const SessionFeedbackProvider = SessionFeedbackContext.Provider;

export function useSessionFeedback() {
  const context = useContext(SessionFeedbackContext);

  if (isEmpty(context)) {
    throw new Error(
      'useSessionFeedback should be used inside a SessionFeedbackContext',
    );
  }

  return context;
}
